/* svelte-comps/PostcardContainer.svelte generated by Svelte v3.59.1 */
import {
	SvelteComponent,
	add_render_callback,
	append,
	attr,
	check_outros,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	globals,
	group_outros,
	init,
	insert,
	listen,
	mount_component,
	noop,
	run_all,
	safe_not_equal,
	set_data,
	set_input_value,
	set_style,
	space,
	src_url_equal,
	text,
	transition_in,
	transition_out
} from "svelte/internal";

const { window: window_1 } = globals;
import Carousel from './Carousel.svelte';
import downArrow from '../../img/down-arrow.svg';
import { onMount, onDestroy } from 'svelte';
import { Circle } from 'svelte-loading-spinners';
import allinthis from '../../img/outdoorstate_allinthis.jpg';
import earth from '../../img/outdoorstate_earth.jpg';
import snowboard from '../../img/outdoorstatesnowboard.jpg';
import darkblue from '../../img/rp-roberts-darkblue.jpg';
import jcollins1 from '../../img/JeremyCollins1.png';
import jcollins2 from '../../img/JeremyCollins2.png';
import backPreview from '../../img/postcard_back_v4.png';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[48] = list[i].title;
	child_ctx[49] = list[i].step;
	return child_ctx;
}

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[10] = list[i];
	return child_ctx;
}

// (465:8) {#if previewPostcard}
function create_if_block_7(ctx) {
	let button;
	let mounted;
	let dispose;

	return {
		c() {
			button = element("button");
			button.textContent = "Close Preview";
			attr(button, "class", "close-preview");
		},
		m(target, anchor) {
			insert(target, button, anchor);

			if (!mounted) {
				dispose = listen(button, "click", /*togglePreview*/ ctx[21]);
				mounted = true;
			}
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(button);
			mounted = false;
			dispose();
		}
	};
}

// (472:8) {#if step != 1 && step != 5}
function create_if_block_6(ctx) {
	let button;
	let img;
	let img_src_value;

	return {
		c() {
			button = element("button");
			img = element("img");
			if (!src_url_equal(img.src, img_src_value = downArrow)) attr(img, "src", img_src_value);
			attr(img, "alt", "arrow");
			attr(button, "class", "accordion-button");
		},
		m(target, anchor) {
			insert(target, button, anchor);
			append(button, img);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(button);
		}
	};
}

// (484:6) {:else}
function create_else_block(ctx) {
	let div;
	let current_block_type_index;
	let if_block;
	let current;
	const if_block_creators = [create_if_block_1, create_if_block_2, create_if_block_3, create_if_block_5];
	const if_blocks = [];

	function select_block_type_1(ctx, dirty) {
		if (!/*previewPostcard*/ ctx[8] && /*step*/ ctx[49] == 2) return 0;
		if (!/*previewPostcard*/ ctx[8] && /*step*/ ctx[49] == 3) return 1;
		if (!/*previewPostcard*/ ctx[8] && /*step*/ ctx[49] == 4) return 2;
		if (/*step*/ ctx[49] == 5) return 3;
		return -1;
	}

	if (~(current_block_type_index = select_block_type_1(ctx, [-1, -1]))) {
		if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	}

	return {
		c() {
			div = element("div");
			if (if_block) if_block.c();
			attr(div, "class", "step-wrapper");
		},
		m(target, anchor) {
			insert(target, div, anchor);

			if (~current_block_type_index) {
				if_blocks[current_block_type_index].m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_1(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if (~current_block_type_index) {
					if_blocks[current_block_type_index].p(ctx, dirty);
				}
			} else {
				if (if_block) {
					group_outros();

					transition_out(if_blocks[previous_block_index], 1, 1, () => {
						if_blocks[previous_block_index] = null;
					});

					check_outros();
				}

				if (~current_block_type_index) {
					if_block = if_blocks[current_block_type_index];

					if (!if_block) {
						if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
						if_block.c();
					} else {
						if_block.p(ctx, dirty);
					}

					transition_in(if_block, 1);
					if_block.m(div, null);
				} else {
					if_block = null;
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);

			if (~current_block_type_index) {
				if_blocks[current_block_type_index].d();
			}
		}
	};
}

// (479:6) {#if step == 1}
function create_if_block(ctx) {
	let carousel;
	let current;

	carousel = new Carousel({
			props: {
				content: /*cards*/ ctx[20],
				hoverSelectCard: /*hoverSelectCard*/ ctx[24],
				selectCard: /*selectCard*/ ctx[23]
			}
		});

	return {
		c() {
			create_component(carousel.$$.fragment);
		},
		m(target, anchor) {
			mount_component(carousel, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(carousel.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(carousel.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(carousel, detaching);
		}
	};
}

// (560:30) 
function create_if_block_5(ctx) {
	let div7;
	let button;
	let t0_value = `See ${/*viewBack*/ ctx[11] ? 'Front' : 'Back'}` + "";
	let t0;
	let t1;
	let div0;
	let t2;
	let t3;
	let div1;
	let t4;
	let div2;
	let t5;
	let t6;
	let div3;
	let t7;
	let t8;
	let div4;
	let t9;
	let t10;
	let div5;

	let t11_value = `${/*city*/ ctx[6]}${/*city*/ ctx[6] && /*state*/ ctx[10]
	? `, ${/*state*/ ctx[10]}`
	: /*state*/ ctx[10]} ${/*zip*/ ctx[7] || ''}` + "";

	let t11;
	let div5_class_value;
	let t12;
	let div6;

	let t13_value = (/*selectedPreview*/ ctx[9]
	? `Artist: ${/*selectedPreview*/ ctx[9].artist}`
	: '') + "";

	let t13;
	let t14;
	let img0;
	let img0_src_value;
	let t15;
	let img1;
	let img1_src_value;
	let div7_class_value;
	let mounted;
	let dispose;

	return {
		c() {
			div7 = element("div");
			button = element("button");
			t0 = text(t0_value);
			t1 = space();
			div0 = element("div");
			t2 = text(/*full_name*/ ctx[18]);
			t3 = space();
			div1 = element("div");
			t4 = space();
			div2 = element("div");
			t5 = text(/*full_name*/ ctx[18]);
			t6 = space();
			div3 = element("div");
			t7 = text(/*address1*/ ctx[4]);
			t8 = space();
			div4 = element("div");
			t9 = text(/*address2*/ ctx[5]);
			t10 = space();
			div5 = element("div");
			t11 = text(t11_value);
			t12 = space();
			div6 = element("div");
			t13 = text(t13_value);
			t14 = space();
			img0 = element("img");
			t15 = space();
			img1 = element("img");
			attr(button, "class", "button toggle-view");
			attr(div0, "class", "name");
			set_style(div0, "visibility", /*viewBack*/ ctx[11] ? 'visible' : 'hidden');
			attr(div1, "class", "message");
			set_style(div1, "visibility", /*viewBack*/ ctx[11] ? 'visible' : 'hidden');
			attr(div2, "class", "address_line1");
			set_style(div2, "visibility", /*viewBack*/ ctx[11] ? 'visible' : 'hidden');
			attr(div3, "class", "address_line2");
			set_style(div3, "visibility", /*viewBack*/ ctx[11] ? 'visible' : 'hidden');
			attr(div4, "class", "address_line3");
			set_style(div4, "visibility", /*viewBack*/ ctx[11] ? 'visible' : 'hidden');
			attr(div5, "class", div5_class_value = /*address2*/ ctx[5] ? 'address_line4' : 'address_line3');
			set_style(div5, "visibility", /*viewBack*/ ctx[11] ? 'visible' : 'hidden');
			attr(div6, "class", "artist-info");
			set_style(div6, "visibility", /*viewBack*/ ctx[11] ? 'visible' : 'hidden');
			attr(img0, "class", "front");
			set_style(img0, "visibility", /*viewBack*/ ctx[11] ? 'hidden' : 'visible');
			if (!src_url_equal(img0.src, img0_src_value = /*frontPreview*/ ctx[17])) attr(img0, "src", img0_src_value);
			attr(img0, "alt", "postcard-front");
			attr(img1, "class", "back");
			set_style(img1, "visibility", /*viewBack*/ ctx[11] ? 'visible' : 'hidden');
			if (!src_url_equal(img1.src, img1_src_value = backPreview)) attr(img1, "src", img1_src_value);
			attr(img1, "alt", "postcard-back");
			attr(div7, "class", div7_class_value = "postcard-preview " + (/*viewBack*/ ctx[11] ? '' : 'hide-text'));
		},
		m(target, anchor) {
			insert(target, div7, anchor);
			append(div7, button);
			append(button, t0);
			append(div7, t1);
			append(div7, div0);
			append(div0, t2);
			append(div7, t3);
			append(div7, div1);
			div1.innerHTML = /*preview_message*/ ctx[14];
			append(div7, t4);
			append(div7, div2);
			append(div2, t5);
			append(div7, t6);
			append(div7, div3);
			append(div3, t7);
			append(div7, t8);
			append(div7, div4);
			append(div4, t9);
			append(div7, t10);
			append(div7, div5);
			append(div5, t11);
			append(div7, t12);
			append(div7, div6);
			append(div6, t13);
			append(div7, t14);
			append(div7, img0);
			append(div7, t15);
			append(div7, img1);

			if (!mounted) {
				dispose = listen(button, "click", /*toggleCardView*/ ctx[22]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty[0] & /*viewBack*/ 2048 && t0_value !== (t0_value = `See ${/*viewBack*/ ctx[11] ? 'Front' : 'Back'}` + "")) set_data(t0, t0_value);
			if (dirty[0] & /*full_name*/ 262144) set_data(t2, /*full_name*/ ctx[18]);

			if (dirty[0] & /*viewBack*/ 2048) {
				set_style(div0, "visibility", /*viewBack*/ ctx[11] ? 'visible' : 'hidden');
			}

			if (dirty[0] & /*preview_message*/ 16384) div1.innerHTML = /*preview_message*/ ctx[14];;

			if (dirty[0] & /*viewBack*/ 2048) {
				set_style(div1, "visibility", /*viewBack*/ ctx[11] ? 'visible' : 'hidden');
			}

			if (dirty[0] & /*full_name*/ 262144) set_data(t5, /*full_name*/ ctx[18]);

			if (dirty[0] & /*viewBack*/ 2048) {
				set_style(div2, "visibility", /*viewBack*/ ctx[11] ? 'visible' : 'hidden');
			}

			if (dirty[0] & /*address1*/ 16) set_data(t7, /*address1*/ ctx[4]);

			if (dirty[0] & /*viewBack*/ 2048) {
				set_style(div3, "visibility", /*viewBack*/ ctx[11] ? 'visible' : 'hidden');
			}

			if (dirty[0] & /*address2*/ 32) set_data(t9, /*address2*/ ctx[5]);

			if (dirty[0] & /*viewBack*/ 2048) {
				set_style(div4, "visibility", /*viewBack*/ ctx[11] ? 'visible' : 'hidden');
			}

			if (dirty[0] & /*city, state, zip*/ 1216 && t11_value !== (t11_value = `${/*city*/ ctx[6]}${/*city*/ ctx[6] && /*state*/ ctx[10]
			? `, ${/*state*/ ctx[10]}`
			: /*state*/ ctx[10]} ${/*zip*/ ctx[7] || ''}` + "")) set_data(t11, t11_value);

			if (dirty[0] & /*address2*/ 32 && div5_class_value !== (div5_class_value = /*address2*/ ctx[5] ? 'address_line4' : 'address_line3')) {
				attr(div5, "class", div5_class_value);
			}

			if (dirty[0] & /*viewBack*/ 2048) {
				set_style(div5, "visibility", /*viewBack*/ ctx[11] ? 'visible' : 'hidden');
			}

			if (dirty[0] & /*selectedPreview*/ 512 && t13_value !== (t13_value = (/*selectedPreview*/ ctx[9]
			? `Artist: ${/*selectedPreview*/ ctx[9].artist}`
			: '') + "")) set_data(t13, t13_value);

			if (dirty[0] & /*viewBack*/ 2048) {
				set_style(div6, "visibility", /*viewBack*/ ctx[11] ? 'visible' : 'hidden');
			}

			if (dirty[0] & /*viewBack*/ 2048) {
				set_style(img0, "visibility", /*viewBack*/ ctx[11] ? 'hidden' : 'visible');
			}

			if (dirty[0] & /*frontPreview*/ 131072 && !src_url_equal(img0.src, img0_src_value = /*frontPreview*/ ctx[17])) {
				attr(img0, "src", img0_src_value);
			}

			if (dirty[0] & /*viewBack*/ 2048) {
				set_style(img1, "visibility", /*viewBack*/ ctx[11] ? 'visible' : 'hidden');
			}

			if (dirty[0] & /*viewBack*/ 2048 && div7_class_value !== (div7_class_value = "postcard-preview " + (/*viewBack*/ ctx[11] ? '' : 'hide-text'))) {
				attr(div7, "class", div7_class_value);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div7);
			mounted = false;
			dispose();
		}
	};
}

// (539:50) 
function create_if_block_3(ctx) {
	let span;
	let p;
	let t1;
	let button0;
	let current_block_type_index;
	let if_block;
	let button0_disabled_value;
	let t2;
	let button1;
	let current;
	let mounted;
	let dispose;
	const if_block_creators = [create_if_block_4, create_else_block_1];
	const if_blocks = [];

	function select_block_type_2(ctx, dirty) {
		if (/*loading*/ ctx[12]) return 0;
		return 1;
	}

	current_block_type_index = select_block_type_2(ctx, [-1, -1]);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			span = element("span");
			p = element("p");
			p.textContent = "We'll mail your postcard a few weeks before the election.";
			t1 = space();
			button0 = element("button");
			if_block.c();
			t2 = space();
			button1 = element("button");
			button1.textContent = "Preview Postcard";
			attr(p, "class", "send-it-message");
			button0.disabled = button0_disabled_value = !/*postcardReady*/ ctx[15];
			attr(button0, "class", "button postcard-submit");
			attr(button1, "class", "button toggle-preview");
			attr(span, "class", "button-group");
		},
		m(target, anchor) {
			insert(target, span, anchor);
			append(span, p);
			append(span, t1);
			append(span, button0);
			if_blocks[current_block_type_index].m(button0, null);
			append(span, t2);
			append(span, button1);
			current = true;

			if (!mounted) {
				dispose = [
					listen(button0, "click", /*click_handler*/ ctx[42]),
					listen(button1, "click", /*togglePreview*/ ctx[21])
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_2(ctx, dirty);

			if (current_block_type_index !== previous_block_index) {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				} else {
					
				}

				transition_in(if_block, 1);
				if_block.m(button0, null);
			}

			if (!current || dirty[0] & /*postcardReady*/ 32768 && button0_disabled_value !== (button0_disabled_value = !/*postcardReady*/ ctx[15])) {
				button0.disabled = button0_disabled_value;
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(span);
			if_blocks[current_block_type_index].d();
			mounted = false;
			run_all(dispose);
		}
	};
}

// (496:50) 
function create_if_block_2(ctx) {
	let div;
	let input0;
	let t0;
	let input1;
	let t1;
	let input2;
	let t2;
	let input3;
	let t3;
	let input4;
	let t4;
	let input5;
	let t5;
	let select;
	let option;
	let t7;
	let input6;
	let mounted;
	let dispose;
	let each_value_1 = /*states*/ ctx[19];
	let each_blocks = [];

	for (let i = 0; i < each_value_1.length; i += 1) {
		each_blocks[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	}

	return {
		c() {
			div = element("div");
			input0 = element("input");
			t0 = space();
			input1 = element("input");
			t1 = space();
			input2 = element("input");
			t2 = space();
			input3 = element("input");
			t3 = space();
			input4 = element("input");
			t4 = space();
			input5 = element("input");
			t5 = space();
			select = element("select");
			option = element("option");
			option.textContent = "Select State";

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t7 = space();
			input6 = element("input");
			attr(input0, "placeholder", "First");
			attr(input0, "class", "first");
			attr(input1, "placeholder", "Last");
			attr(input1, "class", "last");
			attr(input2, "placeholder", "Email (Optional)");
			attr(input2, "type", "email");
			attr(input2, "class", "email");
			attr(input3, "placeholder", "Address 1");
			attr(input3, "class", "address1");
			attr(input4, "placeholder", "Address 2");
			attr(input4, "class", "address2");
			attr(input5, "placeholder", "City");
			attr(input5, "class", "city");
			option.__value = "Select State";
			option.value = option.__value;
			attr(select, "name", "state");
			attr(select, "class", "state");
			attr(input6, "placeholder", "Zip Code");
			attr(input6, "class", "zip");
			attr(div, "class", "postcard-address-form");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, input0);
			set_input_value(input0, /*firstname*/ ctx[1]);
			append(div, t0);
			append(div, input1);
			set_input_value(input1, /*lastname*/ ctx[2]);
			append(div, t1);
			append(div, input2);
			set_input_value(input2, /*email*/ ctx[3]);
			append(div, t2);
			append(div, input3);
			set_input_value(input3, /*address1*/ ctx[4]);
			append(div, t3);
			append(div, input4);
			set_input_value(input4, /*address2*/ ctx[5]);
			append(div, t4);
			append(div, input5);
			set_input_value(input5, /*city*/ ctx[6]);
			append(div, t5);
			append(div, select);
			append(select, option);

			for (let i = 0; i < each_blocks.length; i += 1) {
				if (each_blocks[i]) {
					each_blocks[i].m(select, null);
				}
			}

			append(div, t7);
			append(div, input6);
			set_input_value(input6, /*zip*/ ctx[7]);

			if (!mounted) {
				dispose = [
					listen(input0, "input", /*input0_input_handler*/ ctx[35]),
					listen(input1, "input", /*input1_input_handler*/ ctx[36]),
					listen(input2, "input", /*input2_input_handler*/ ctx[37]),
					listen(input3, "input", /*input3_input_handler*/ ctx[38]),
					listen(input4, "input", /*input4_input_handler*/ ctx[39]),
					listen(input5, "input", /*input5_input_handler*/ ctx[40]),
					listen(select, "change", /*handleStateChange*/ ctx[27]),
					listen(input6, "input", /*input6_input_handler*/ ctx[41]),
					listen(div, "click", /*enterStep2or3*/ ctx[25])
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty[0] & /*firstname*/ 2 && input0.value !== /*firstname*/ ctx[1]) {
				set_input_value(input0, /*firstname*/ ctx[1]);
			}

			if (dirty[0] & /*lastname*/ 4 && input1.value !== /*lastname*/ ctx[2]) {
				set_input_value(input1, /*lastname*/ ctx[2]);
			}

			if (dirty[0] & /*email*/ 8 && input2.value !== /*email*/ ctx[3]) {
				set_input_value(input2, /*email*/ ctx[3]);
			}

			if (dirty[0] & /*address1*/ 16 && input3.value !== /*address1*/ ctx[4]) {
				set_input_value(input3, /*address1*/ ctx[4]);
			}

			if (dirty[0] & /*address2*/ 32 && input4.value !== /*address2*/ ctx[5]) {
				set_input_value(input4, /*address2*/ ctx[5]);
			}

			if (dirty[0] & /*city*/ 64 && input5.value !== /*city*/ ctx[6]) {
				set_input_value(input5, /*city*/ ctx[6]);
			}

			if (dirty[0] & /*states*/ 524288) {
				each_value_1 = /*states*/ ctx[19];
				let i;

				for (i = 0; i < each_value_1.length; i += 1) {
					const child_ctx = get_each_context_1(ctx, each_value_1, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block_1(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(select, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value_1.length;
			}

			if (dirty[0] & /*zip*/ 128 && input6.value !== /*zip*/ ctx[7]) {
				set_input_value(input6, /*zip*/ ctx[7]);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);
			destroy_each(each_blocks, detaching);
			mounted = false;
			run_all(dispose);
		}
	};
}

// (486:10) {#if !previewPostcard && step == 2}
function create_if_block_1(ctx) {
	let textarea;
	let mounted;
	let dispose;

	return {
		c() {
			textarea = element("textarea");
			attr(textarea, "placeholder", "Enter Message Here... (Optional)");
			attr(textarea, "class", "postcard-textarea");
			attr(textarea, "maxlength", "150");
			attr(textarea, "wrap", "hard");
		},
		m(target, anchor) {
			insert(target, textarea, anchor);
			set_input_value(textarea, /*message*/ ctx[0]);

			if (!mounted) {
				dispose = [
					listen(textarea, "click", /*enterStep2or3*/ ctx[25]),
					listen(textarea, "keypress", /*checkMessageLength*/ ctx[28]),
					listen(textarea, "input", /*textarea_input_handler*/ ctx[34])
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty[0] & /*message*/ 1) {
				set_input_value(textarea, /*message*/ ctx[0]);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(textarea);
			mounted = false;
			run_all(dispose);
		}
	};
}

// (550:16) {:else}
function create_else_block_1(ctx) {
	let t;

	return {
		c() {
			t = text("Send It!");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (548:16) {#if loading}
function create_if_block_4(ctx) {
	let circle;
	let current;

	circle = new Circle({
			props: { size: "20", color: "#234B64", unit: "px" }
		});

	return {
		c() {
			create_component(circle.$$.fragment);
		},
		m(target, anchor) {
			mount_component(circle, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(circle.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(circle.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(circle, detaching);
		}
	};
}

// (530:16) {#each states as state}
function create_each_block_1(ctx) {
	let option;
	let t_value = /*state*/ ctx[10].display + "";
	let t;
	let option_value_value;

	return {
		c() {
			option = element("option");
			t = text(t_value);
			option.__value = option_value_value = /*state*/ ctx[10].value;
			option.value = option.__value;
		},
		m(target, anchor) {
			insert(target, option, anchor);
			append(option, t);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(option);
		}
	};
}

// (461:2) {#each filteredSteps as { title, step }}
function create_each_block(ctx) {
	let div;
	let span;
	let h3;
	let t0_value = /*title*/ ctx[48] + "";
	let t0;
	let t1;
	let t2;
	let t3;
	let current_block_type_index;
	let if_block2;
	let t4;
	let div_class_value;
	let current;
	let if_block0 = /*previewPostcard*/ ctx[8] && create_if_block_7(ctx);
	let if_block1 = /*step*/ ctx[49] != 1 && /*step*/ ctx[49] != 5 && create_if_block_6(ctx);
	const if_block_creators = [create_if_block, create_else_block];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*step*/ ctx[49] == 1) return 0;
		return 1;
	}

	current_block_type_index = select_block_type(ctx, [-1, -1]);
	if_block2 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			div = element("div");
			span = element("span");
			h3 = element("h3");
			t0 = text(t0_value);
			t1 = space();
			if (if_block0) if_block0.c();
			t2 = space();
			if (if_block1) if_block1.c();
			t3 = space();
			if_block2.c();
			t4 = space();
			attr(h3, "class", "step-header");
			attr(span, "class", "header-wrapper");

			attr(div, "class", div_class_value = `step${/*step*/ ctx[49]}${/*previewPostcard*/ ctx[8] && /*step*/ ctx[49] == 5
			? '-preview'
			: ''}`);
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, span);
			append(span, h3);
			append(h3, t0);
			append(span, t1);
			if (if_block0) if_block0.m(span, null);
			append(span, t2);
			if (if_block1) if_block1.m(span, null);
			append(div, t3);
			if_blocks[current_block_type_index].m(div, null);
			append(div, t4);
			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*filteredSteps*/ 65536) && t0_value !== (t0_value = /*title*/ ctx[48] + "")) set_data(t0, t0_value);

			if (/*previewPostcard*/ ctx[8]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_7(ctx);
					if_block0.c();
					if_block0.m(span, t2);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (/*step*/ ctx[49] != 1 && /*step*/ ctx[49] != 5) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_6(ctx);
					if_block1.c();
					if_block1.m(span, null);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block2 = if_blocks[current_block_type_index];

				if (!if_block2) {
					if_block2 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block2.c();
				} else {
					if_block2.p(ctx, dirty);
				}

				transition_in(if_block2, 1);
				if_block2.m(div, t4);
			}

			if (!current || dirty[0] & /*filteredSteps, previewPostcard*/ 65792 && div_class_value !== (div_class_value = `step${/*step*/ ctx[49]}${/*previewPostcard*/ ctx[8] && /*step*/ ctx[49] == 5
			? '-preview'
			: ''}`)) {
				attr(div, "class", div_class_value);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block2);
			current = true;
		},
		o(local) {
			transition_out(if_block2);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			if_blocks[current_block_type_index].d();
		}
	};
}

function create_fragment(ctx) {
	let div;
	let current;
	let mounted;
	let dispose;
	add_render_callback(/*onwindowresize*/ ctx[33]);
	let each_value = /*filteredSteps*/ ctx[16];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	return {
		c() {
			div = element("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			attr(div, "class", "postcard-wrapper");
		},
		m(target, anchor) {
			insert(target, div, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				if (each_blocks[i]) {
					each_blocks[i].m(div, null);
				}
			}

			current = true;

			if (!mounted) {
				dispose = listen(window_1, "resize", /*onwindowresize*/ ctx[33]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty[0] & /*filteredSteps, previewPostcard, cards, hoverSelectCard, selectCard, message, enterStep2or3, checkMessageLength, zip, handleStateChange, states, city, address2, address1, email, lastname, firstname, togglePreview, postcardReady, handleSubmit, loading, viewBack, frontPreview, selectedPreview, state, full_name, preview_message, toggleCardView*/ 536862719) {
				each_value = /*filteredSteps*/ ctx[16];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(div, null);
					}
				}

				group_outros();

				for (i = each_value.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_each(each_blocks, detaching);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let full_name;
	let full_address;
	let postcard;
	let hoverPreview;
	let selectedPreview;
	let frontPreview;
	let artistname;
	let filteredSteps;
	let postcardReady;
	let preview_message;

	let states = [
		{ value: "AL", display: 'Alabama' },
		{ value: "AK", display: 'Alaska' },
		{ value: "AZ", display: 'Arizona' },
		{ value: "AR", display: 'Arkansas' },
		{ value: "CA", display: 'California' },
		{ value: "CO", display: 'Colorado' },
		{ value: "CT", display: 'Connecticut' },
		{ value: "DE", display: 'Delaware' },
		{
			value: "DC",
			display: 'District Of Columbia'
		},
		{ value: "FL", display: 'Florida' },
		{ value: "GA", display: 'Georgia' },
		{ value: "HI", display: 'Hawaii' },
		{ value: "ID", display: 'Idaho' },
		{ value: "IL", display: 'Illinois' },
		{ value: "IN", display: 'Indiana' },
		{ value: "IA", display: 'Iowa' },
		{ value: "KS", display: 'Kansas' },
		{ value: "KY", display: 'Kentucky' },
		{ value: "LA", display: 'Louisiana' },
		{ value: "ME", display: 'Maine' },
		{ value: "MD", display: 'Maryland' },
		{ value: "MA", display: 'Massachusetts' },
		{ value: "MI", display: 'Michigan' },
		{ value: "MN", display: 'Minnesota' },
		{ value: "MS", display: 'Mississippi' },
		{ value: "MO", display: 'Missouri' },
		{ value: "MT", display: 'Montana' },
		{ value: "NE", display: 'Nebraska' },
		{ value: "NV", display: 'Nevada' },
		{ value: "NH", display: 'New Hampshire' },
		{ value: "NJ", display: 'New Jersey' },
		{ value: "NM", display: 'New Mexico' },
		{ value: "NY", display: 'New York' },
		{ value: "NC", display: 'North Carolina' },
		{ value: "ND", display: 'North Dakota' },
		{ value: "OH", display: 'Ohio' },
		{ value: "OK", display: 'Oklahoma' },
		{ value: "OR", display: 'Oregon' },
		{ value: "PA", display: 'Pennsylvania' },
		{ value: "RI", display: 'Rhode Island' },
		{ value: "SC", display: 'South Carolina' },
		{ value: "SD", display: 'South Dakota' },
		{ value: "TN", display: 'Tennessee' },
		{ value: "TX", display: 'Texas' },
		{ value: "UT", display: 'Utah' },
		{ value: "VT", display: 'Vermont' },
		{ value: "VA", display: 'Virginia' },
		{ value: "WA", display: 'Washington' },
		{ value: "WV", display: 'West Virginia' },
		{ value: "WI", display: 'Wisconsin' },
		{ value: "WY", display: 'Wyoming' }
	];

	// view back of postcard preview
	let viewBack = false;

	let manualFlip = false;

	// used to activate loading spinner when creating postcard
	let loading = false;

	// form variables;
	let message = '';

	let firstname = '';
	let lastname = '';
	let email = '';
	let address1 = '';
	let address2 = '';
	let state = '';
	let city = '';
	let zip = '';
	let postcard_type = '';
	let postcard_hover = '';
	let screenWidth;

	// postcard options
	let cards = [
		{
			type: 'allinthis',
			img: allinthis,
			artist: 'Hannah Eddy'
		},
		{
			type: 'earth',
			img: earth,
			artist: 'Hannah Eddy'
		},
		{
			type: 'snowboard',
			img: snowboard,
			artist: 'Hannah Eddy'
		},
		{
			type: 'darkblue',
			img: darkblue,
			artist: 'RP Roberts'
		},
		{
			type: 'jcollins1',
			img: jcollins1,
			artist: 'Jeremy Collins'
		},
		{
			type: 'jcollins2',
			img: jcollins2,
			artist: 'Jeremy Collins'
		}
	];

	let steps = [
		{
			title: 'Step 1: Choose a Design',
			step: 1
		},
		{
			title: 'Step 2: Customize Your Pledge',
			step: 2
		},
		{ title: 'Step 3: Address It', step: 3 },
		{ title: 'Step 4: Send Postcard', step: 4 },
		{ title: 'Preview Postcard', step: 5 }
	];

	let previewPostcard = false;

	function togglePreview() {
		$$invalidate(8, previewPostcard = !previewPostcard);
	}

	function toggleCardView() {
		manualFlip = true;
		$$invalidate(11, viewBack = !viewBack);
	}

	function selectCard(card, advanceToStep2) {
		$$invalidate(29, postcard_type = card);

		if (advanceToStep2) {
			if (screenWidth > 600) return;
			jQuery(".step2").addClass('active').find('.step-wrapper').slideDown('fast');
		}
	}

	function hoverSelectCard(viewToggle, card) {
		$$invalidate(30, postcard_hover = card);
		$$invalidate(11, viewBack = viewToggle);
	}

	function enterStep2or3() {
		// only flip preview if user hasn't already flipped
		$$invalidate(11, viewBack = true);
	}

	function handleSubmit() {
		$$invalidate(12, loading = true);

		jQuery(document).ready(function () {
			jQuery.post(
				ajaxurl,
				{
					// wp ajax action
					action: 'submit_postcard',
					// data
					postcard
				},
				function () {
					const url = `${document.location.origin}/postcard-thank-you`;
					clearForm();
					window.location.href = url;
				}
			);

			return false;
		});
	}

	function handleStateChange(e) {
		$$invalidate(10, state = e.target.value);
	}

	function checkMessageLength(e) {
		if (e.key === 'Enter') {
			if ((message.match(/\n/g) || []).length >= 7) {
				e.preventDefault();
				return false;
			}
		}
	}

	// turn headers into accordion buttons
	jQuery(document).ready(function () {
		jQuery(document).on("click", ".header-wrapper:not(:first):not(:last)", function () {
			if (screenWidth > 650) return;
			jQuery(this).parent().find('.step-wrapper').slideToggle('fast');
			jQuery(".header-wrapper").not(this).parent().find('.step-wrapper').slideUp('fast');
		});

		// coming back from preview open step4
		jQuery(document).on("click", ".close-preview", function () {
			if (screenWidth > 650) return;
			jQuery(".step4").find('.step-wrapper').slideToggle('fast');
		});

		// zip validation
		jQuery('.zip').bind('keypress', function (event) {
			var regnum = new RegExp("^[0-9\b]+$");
			var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
			var pacvalue = jQuery(this).val().length;

			if (!regnum.test(key) || pacvalue >= 5) {
				return false;
			} else {
				return true;
			}
		});
	});

	// set all variables back to default values
	function clearForm() {
		$$invalidate(0, message = '');
		$$invalidate(1, firstname = '');
		$$invalidate(2, lastname = '');
		$$invalidate(3, email = '');
		$$invalidate(4, address1 = '');
		$$invalidate(5, address2 = '');
		$$invalidate(10, state = '');
		$$invalidate(6, city = '');
		$$invalidate(7, zip = '');
		$$invalidate(29, postcard_type = '');
		$$invalidate(12, loading = false);
		$$invalidate(11, viewBack = false);
		manualFlip = false;
	}

	;

	function onwindowresize() {
		$$invalidate(13, screenWidth = window_1.innerWidth)
	}

	function textarea_input_handler() {
		message = this.value;
		$$invalidate(0, message);
	}

	function input0_input_handler() {
		firstname = this.value;
		$$invalidate(1, firstname);
	}

	function input1_input_handler() {
		lastname = this.value;
		$$invalidate(2, lastname);
	}

	function input2_input_handler() {
		email = this.value;
		$$invalidate(3, email);
	}

	function input3_input_handler() {
		address1 = this.value;
		$$invalidate(4, address1);
	}

	function input4_input_handler() {
		address2 = this.value;
		$$invalidate(5, address2);
	}

	function input5_input_handler() {
		city = this.value;
		$$invalidate(6, city);
	}

	function input6_input_handler() {
		zip = this.value;
		$$invalidate(7, zip);
	}

	const click_handler = () => handleSubmit();

	$$self.$$.update = () => {
		if ($$self.$$.dirty[0] & /*firstname, lastname*/ 6) {
			$: $$invalidate(18, full_name = `${firstname} ${lastname}`);
		}

		if ($$self.$$.dirty[0] & /*address1, address2, city, state, zip*/ 1264) {
			$: full_address = `${address1} ${address2} ${city || ''}${city && ','} ${state || ''} ${zip || ''}`;
		}

		if ($$self.$$.dirty[0] & /*postcard_type*/ 536870912) {
			$: $$invalidate(9, selectedPreview = _.find(cards, c => c.type === postcard_type));
		}

		if ($$self.$$.dirty[0] & /*selectedPreview*/ 512) {
			$: $$invalidate(31, artistname = selectedPreview ? selectedPreview.artist : '');
		}

		if ($$self.$$.dirty[0] & /*firstname, lastname, address1, address2, email, message, city, state, zip, postcard_type*/ 536872191 | $$self.$$.dirty[1] & /*artistname*/ 1) {
			$: postcard = {
				firstname,
				lastname,
				address1,
				address2,
				email,
				message,
				city,
				state,
				zip,
				artistname,
				postcard_type
			};
		}

		if ($$self.$$.dirty[0] & /*postcard_hover*/ 1073741824) {
			$: $$invalidate(32, hoverPreview = _.find(cards, c => c.type === postcard_hover));
		}

		if ($$self.$$.dirty[0] & /*postcard_type, postcard_hover, selectedPreview*/ 1610613248) {
			$: if (postcard_type && !postcard_hover) {
				$$invalidate(17, frontPreview = selectedPreview.img);
			}
		}

		if ($$self.$$.dirty[0] & /*postcard_hover*/ 1073741824 | $$self.$$.dirty[1] & /*hoverPreview*/ 2) {
			$: if (postcard_hover) {
				$$invalidate(17, frontPreview = hoverPreview.img);
			}
		}

		if ($$self.$$.dirty[0] & /*postcard_hover, postcard_type*/ 1610612736) {
			$: if (!postcard_hover && !postcard_type) {
				$$invalidate(17, frontPreview = `https://via.placeholder.com/720x480/00263e/FFFFFF?text=Select a postcard design`);
			}
		}

		if ($$self.$$.dirty[0] & /*previewPostcard*/ 256) {
			$: $$invalidate(16, filteredSteps = previewPostcard ? steps.filter(s => s.step == 5) : steps);
		}

		if ($$self.$$.dirty[0] & /*firstname, lastname, address1, city, state, zip, postcard_type*/ 536872150) {
			$: $$invalidate(15, postcardReady = firstname !== '' && lastname !== '' && // email !== '' &&
			address1 !== '' && city !== '' && state !== '' && zip !== '' && postcard_type !== '');
		}

		if ($$self.$$.dirty[0] & /*message*/ 1) {
			$: $$invalidate(14, preview_message = encodeURI(message).replace(/%0A/g, '<br/>'));
		}
	};

	$: $$invalidate(17, frontPreview = '');

	return [
		message,
		firstname,
		lastname,
		email,
		address1,
		address2,
		city,
		zip,
		previewPostcard,
		selectedPreview,
		state,
		viewBack,
		loading,
		screenWidth,
		preview_message,
		postcardReady,
		filteredSteps,
		frontPreview,
		full_name,
		states,
		cards,
		togglePreview,
		toggleCardView,
		selectCard,
		hoverSelectCard,
		enterStep2or3,
		handleSubmit,
		handleStateChange,
		checkMessageLength,
		postcard_type,
		postcard_hover,
		artistname,
		hoverPreview,
		onwindowresize,
		textarea_input_handler,
		input0_input_handler,
		input1_input_handler,
		input2_input_handler,
		input3_input_handler,
		input4_input_handler,
		input5_input_handler,
		input6_input_handler,
		click_handler
	];
}

class PostcardContainer extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {}, null, [-1, -1]);
	}
}

export default PostcardContainer;